import useSWR from 'swr';

export interface SubscriptionState {
  status: string | null;
  planName: 'Starter' | 'Pro' | null;
  isTrialing: boolean;
  isActive: boolean;
  hasValidAccess: boolean;
  trialEndsAt: string | null;
  trialDaysRemaining: number;
  enrichmentLimit: number;
}

export interface EnrichmentUsage {
  count: number;
  limit: number;
  remaining: number;
  hasExceeded: boolean;
  isTrialing: boolean;
  trialDaysRemaining: number;
  planName: string | null;
  subscriptionStatus: string | null;
}

interface Workspace {
  id: number;
  name: string;
  stripeSubscriptionId: string | null;
  subscription: SubscriptionState;
  isFreeAccount?: boolean;
}

export function useSubscription() {
  const { data: team, error, isLoading, mutate } = useSWR<Workspace>('/api/team');

  const subscription = team?.subscription ?? null;

  return {
    subscription,
    team,
    isLoading,
    error,
    mutate,
    // Convenience accessors
    isTrialing: subscription?.isTrialing ?? false,
    isActive: subscription?.isActive ?? false,
    hasValidAccess: subscription?.hasValidAccess ?? false,
    planName: subscription?.planName ?? null,
    trialDaysRemaining: subscription?.trialDaysRemaining ?? 0,
    enrichmentLimit: subscription?.enrichmentLimit ?? 0,
    needsCheckout: team && !team.stripeSubscriptionId && !team.isFreeAccount,
  };
}

export function useEnrichmentUsage() {
  const { data, error, isLoading, mutate } = useSWR<EnrichmentUsage>(
    '/api/enrichment-usage'
  );

  return {
    usage: data,
    isLoading,
    error,
    mutate,
    // Convenience accessors
    count: data?.count ?? 0,
    limit: data?.limit ?? 0,
    remaining: data?.remaining ?? 0,
    hasExceeded: data?.hasExceeded ?? false,
    isTrialing: data?.isTrialing ?? false,
    canEnrich: (data?.remaining ?? 0) > 0,
  };
}
